import { RailsArray, useQueryParamState } from "src/hooks/use_query_param_state"

export const useNightViewFilters = () => {
  const [search, setSearch] = useQueryParamState("search", {
    type: String,
    defaultValue: "",
  })
  const [arrival, setArrival] = useQueryParamState("arrival", {
    type: Boolean,
    defaultValue: false,
  })
  const [departure, setDeparture] = useQueryParamState("departure", {
    type: Boolean,
    defaultValue: false,
  })
  const [bookingType, setBookingType] = useQueryParamState("booking_type", {
    type: String,
    defaultValue: "",
  })
  const [selectedSpaceGroups, setSelectedSpaceGroups] = useQueryParamState(
    "space_groups",
    {
      type: RailsArray,
      defaultValue: [],
    }
  )
  const [showUnassigned, setShowUnassigned] = useQueryParamState("unassigned", {
    type: Boolean,
    defaultValue: false,
  })
  const [insurance, setInsurance] = useQueryParamState("insurance", {
    type: RailsArray,
    defaultValue: [],
  })

  // Derived: which stat card is active
  const activeStatCard = arrival
    ? "arrivals"
    : departure
    ? "departures"
    : "total"

  // Handler for stat card clicks
  const setActiveStatCard = (card) => {
    if (card === "arrivals") {
      setArrival(true)
      setDeparture(false)
    } else if (card === "departures") {
      setArrival(false)
      setDeparture(true)
    } else {
      // "total" - clear both
      setArrival(false)
      setDeparture(false)
    }
  }

  return {
    // Filter values
    search,
    arrival,
    departure,
    bookingType,
    selectedSpaceGroups,
    showUnassigned,
    insurance,
    // Setters
    setSearch,
    setBookingType,
    setSelectedSpaceGroups,
    setShowUnassigned,
    setInsurance,
    // Stat card helpers
    activeStatCard,
    setActiveStatCard,
  }
}
